import { newestStudies, studyExports } from './studyMetadata.js';

// Namespace identities so identical folder names/export stems never mix roots.
export function combinedStudies(primary = [], secondary = []) {
  const tag = (studies, source) =>
    studyExports(studies).map((study) => ({
      ...study,
      id: `${source}:${study.id}`,
      studySource: source,
      sourceStudyKey: study.id,
    }));
  return newestStudies([...tag(primary, 'primary'), ...tag(secondary, 'secondary')]);
}
